import { useLocation } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export function OrganizationSchema() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: siteConfig.name,
          url: siteConfig.url,
          description: siteConfig.description,
          email: siteConfig.contactEmail,
          telephone: siteConfig.contactPhone,
          address: {
            '@type': 'PostalAddress',
            addressLocality: '北京',
            addressCountry: 'CN',
          },
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            telephone: siteConfig.contactPhone,
            email: siteConfig.contactEmail,
          },
        }),
      }}
    />
  );
}

export function WebsiteSchema() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: siteConfig.name,
          url: siteConfig.url,
          description: siteConfig.description,
          potentialAction: {
            '@type': 'SearchAction',
            target: `${siteConfig.url}/search?q={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        }),
      }}
    />
  );
}

export function WebPageSchema({ pageTitle, pageDescription }: { pageTitle: string; pageDescription: string }) {
  const location = useLocation();

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: pageTitle,
          description: pageDescription,
          url: `${siteConfig.url}${location.pathname}`,
        }),
      }}
    />
  );
}

export function FAQSchema({ faqs }: { faqs: { question: string; answer: string }[] }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        }),
      }}
    />
  );
}

export function ArticleSchema({
  title,
  description,
  image,
  author,
  datePublished,
}: {
  title: string;
  description: string;
  image: string;
  author: string;
  datePublished: string;
}) {
  const location = useLocation();

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: title,
          description: description,
          image: image,
          author: {
            '@type': 'Person',
            name: author,
          },
          datePublished: datePublished,
          publisher: {
            '@type': 'Organization',
            name: siteConfig.name,
          },
          url: `${siteConfig.url}${location.pathname}`,
        }),
      }}
    />
  );
}